<script setup>
const separatorStyling = `pr-4 ml-4 border-white border-opacity-50 border-l h-8`;
</script>

<template>
  <div :class="separatorStyling"></div>
</template>
